import { apiClient } from './axios';
import { PaginationData } from '../models/paginationData';
import type { AppVersionItem, CreateAppVersionRequest, UpdateAppVersionRequest, AppVersionFilterParams } from '../types/appVersion';

export const appVersionApi = {
    getVersions: async (params: AppVersionFilterParams) => {
        const result = await apiClient.get<PaginationData<AppVersionItem>>('/admin/app-versions', {
            page: params.page - 1,
            size: params.size,
            ...(params.platform ? { platform: params.platform } : {}),
        });
        return { ...result, content: result.content ?? [] };
    },

    create: (data: CreateAppVersionRequest) =>
        apiClient.post<AppVersionItem>('/admin/app-versions', data),

    update: (id: number, data: UpdateAppVersionRequest) =>
        apiClient.put<AppVersionItem>(`/admin/app-versions/${id}`, data),

    remove: (id: number) =>
        apiClient.deleteNoData(`/admin/app-versions/${id}`),
};
